import { CONVERSATIONS_API } from "@/utils/apiUrl"
import backend from "@/utils/backend"
import * as types from "./mutation_types"
import { readMessage } from "@/socket/actions"

export const getOne = ({ commit,state,dispatch }) => {

    const url = `${CONVERSATIONS_API}/${state.currentItem?.id ?? null}`
    commit(types.SET_SHOW_LOADING)
    commit(types.SET_HIDE_MESSAGE)

    backend({ url, data: null, method: "GET" }).then(({ data }) => {
        const response = data?.data ?? data;
        commit(types.SET_ITEMS, response);
        commit(types.SET_CURRENT_ITEM,response)
        commit(types.SET_IS_SUCCESS)
        commit(types.SET_MESSAGE, data.message ?? "Super")
        readMessage(state.currentItem?.id ?? null )
        dispatch("messages/list/getAll",null,{root:true})
    }).catch((err) => {
        commit(types.SET_IS_ERROR)
        commit(types.SET_SHOW_MESSAGE)
        commit(types.SET_MESSAGE, (err?.response?.message ?? err.message ?? err))
        commit(types.SET_ITEMS,null)

        dispatch("messages/list/resetData",null,{root:true})

    }).finally(() => {
        commit(types.SET_SHOW_MESSAGE)
        commit(types.SET_HIDE_LOADING)



    })
}

/**
 * Met à jour directement la conversation sans recharger depuis l'API
 * Utilisé pour éviter les rechargements inutiles lors des mises à jour locales
 */
export const updateConversationDirect = ({ commit,state,dispatch }, conversationData) => {
    if (!conversationData || !conversationData.id) {
        return
    }

    console.log('🔍 DEBUG updateConversationDirect - AVANT mise à jour:')
    console.log('  state.item?.agent_id:', state.item?.agent_id)
    console.log('  state.item:', state.item)
    console.log('  conversationData reçu:', conversationData)

    // Sauvegarder l'ancien ID avant la mise à jour
    const oldConversationId = state.item?.id

    // Mettre à jour item et currentItem avec les nouvelles données
    // Utiliser Object.assign pour créer un nouvel objet et forcer la réactivité
    const newItem = state.item ? {...state.item} : {}
    Object.assign(newItem, conversationData)

    console.log('🔍 DEBUG updateConversationDirect - APRÈS fusion:')
    console.log('  newItem.agent_id:', newItem?.agent_id)
    console.log('  newItem:', newItem)

    commit(types.SET_ITEMS, newItem);
    commit(types.SET_CURRENT_ITEM, newItem);
    commit(types.SET_IS_SUCCESS)

    console.log('🔍 DEBUG updateConversationDirect - APRÈS commit:')
    console.log('  state.item?.agent_id:', state.item?.agent_id)
    console.log('  state.item:', state.item)

    // NE PAS appeler readMessage ici pour éviter les rechargements inutiles
    // et les conflits avec les événements WebSocket
    // La conversation est déjà marquée comme lue par le serveur

    // Recharger les messages si on est toujours sur la même conversation
    if (oldConversationId === conversationData.id) {
        dispatch("messages/list/getAll",null,{root:true})
    }
}


export const resetData = ({ commit }) => {
    commit(types.RESET)
}



